import React from 'react';

import { useTranslations } from '~src/commons/utils/translations/translate';

import { PickupLocation } from '../../api/api';
import { useSessionState } from '../global-state';

interface LocationTypeComponentProps {
  location: PickupLocation;
}

export const LocationTypeComponent: React.FC<LocationTypeComponentProps> = ({
  location: locationProp,
}) => {
  const { tICU } = useTranslations();
  const session = useSessionState();

  if (!session.flags.display_location_type) {
    return null;
  }

  const getLocationType = (locationType: string | undefined) => {
    switch (locationType) {
      case 'locker':
        return tICU('widget.LOCATION_TYPE_LOCKER');
      case 'postoffice':
        return tICU('widget.LOCATION_TYPE_POSTOFFICE');
      case 'store':
        return tICU('widget.LOCATION_TYPE_STORE');
      case 'manned':
        return tICU('widget.LOCATION_TYPE_MANNED');
      case 'unknown_pickup_location_type':
      default:
        return null;
    }
  };

  return <span>{getLocationType(locationProp.type)}</span>;
};
